"use client"

import { motion } from "framer-motion"
import { ChevronDown } from "lucide-react"
import LightRays from "./light-rays"

export function Hero() {
  return (
    <section
      className="relative flex min-h-[80vh] flex-col items-center justify-center overflow-hidden px-4 text-center"
      style={{ position: "relative", overflow: "hidden" }}
    >
      
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="max-w-4xl z-[2]"
        style={{ position: "relative", zIndex: 2 }}
      >
        <h2 className="mb-4 text-sm font-bold uppercase tracking-[0.2em] text-primary">Pesona Pendidikan 2025</h2>
        <h1 className="mb-6 text-5xl font-extrabold tracking-tight text-white sm:text-7xl md:text-8xl">
          Game Project<br />Siswa RPL
        </h1>
        <p className="mx-auto mb-10 max-w-2xl text-lg text-muted-foreground sm:text-xl">
          Kumpulan game hasil kreativitas siswa RPL yang dikembangkan untuk melatih logika, desain, dan gameplay.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 1 }}
        className="flex flex-col items-center gap-2 text-sm text-muted-foreground/50 z-[2]"
        style={{
          position: "absolute",
          left: "50%",
          bottom: "2.5rem",
          transform: "translateX(-50%)",
          zIndex: 2,
        }}
      >
        <span>Scroll untuk melihat</span>
        <ChevronDown className="h-4 w-4 animate-bounce" />
      </motion.div>
    </section>
  )}
